import { encodeFunctionData, parseAbi, decodeAbiParameters } from 'viem';

/**
 * 트랜잭션 데이터를 생성하는 유틸리티 함수
 * @param {string} abiString - 함수의 ABI 문자열
 * @param {string} methodName - 실행할 메서드 이름
 * @param {Array} args - 메서드 실행에 필요한 인자 배열
 * @returns {string} 인코딩된 트랜잭션 데이터
 */
export const createTransactionData = (abiString, methodName, args) => {
  const abi = parseAbi([abiString]);
  return encodeFunctionData({
    abi,
    functionName: methodName,
    args,
  });
};

/**
 * ABI 파라미터를 디코딩하는 유틸리티 함수
 * @param {string} abiString - 파라미터의 ABI 문자열
 * @param {string} data - 디코딩할 데이터
 * @returns {Array} 디코딩된 파라미터 값 배열
 */
export const decodeParameters = (abi, data) => {
  return decodeAbiParameters(
    abi,
    data);
};
